export function readPluginConfigString(
  config: Record<string, unknown> | undefined,
  key: string,
): string | undefined {
  const v = config?.[key];
  return typeof v === "string" && v.length > 0 ? v : undefined;
}
